import React, { Component, Fragment } from 'react'
import { inject, observer } from 'mobx-react'
import { Input, Button, Select, Icon, Form, Checkbox } from 'antd'

@inject((store: any) => {
    const { parametersStore, rightsParametersStore, rightsStore, popupStore } = store
    return { parametersStore, rightsParametersStore, rightsStore, popupStore }
})
@observer
export default class EditRightParam extends Component<any, any> {
    state: any = {
        errors: {},
        values: {},
        editMode: false
    }
    toggleEditMode = () => {
        this.setState(prevState => ({ editMode: !prevState.editMode }))
    }
    handleCancelEdit = () => {
        this.setState({ values: {}, editMode: false })
    }
    handleChangeValue = (name, newValue) => {
        let values = { ...this.state.values }
        let editMode = false
        if (name in values) {
            values[name] = newValue
            if (this.props[name] !== newValue) {
                editMode = true
            } else {
                editMode = this.checkEditMode(values)
            }
        } else {
            const { value, link } = this.props
            values = { value, link }
            values[name] = newValue
            if (this.props[name] !== newValue) editMode = true
        }
        this.setState({ values, editMode })
    }
    checkEditMode = values => {
        let editMode = false
        for (let key in values) {
            if (this.props[key] !== values[key]) editMode = true
        }
        return editMode
    }
    handleSubmit = async e => {
        e.preventDefault()
        const { parametersStore, rightsStore, rightsParametersStore, id: parameter_id } = this.props
        const { policy_id, id: right_id, right_param_set_id } = this.props.popupStore.info
        const { values, editMode } = this.state
        if (editMode) {
            await rightsParametersStore
                .updateRightParameter({
                    right_id,
                    policy_id,
                    parameter_id,
                    value: values['value'],
                    link: values['link']
                })
                .then(async res => {
                    await rightsStore.getRightsList({ right_param_set_id, policy_id })
                    await rightsStore.applyFilters()
                    await parametersStore.getParametersList({ policy_id, right_param_set_id, right_id })
                    this.setState({ editMode: false, values: {} })
                })
                .catch(e => console.log(e))
        }
    }
    render() {
        const { name, policy_id, value, link, type } = this.props
        const { editMode, values } = this.state
        let background
        if (editMode) {
            background = '#ffeecf'
        } else if (!policy_id) {
            background = '#f3f2f2'
        } else {
            background = 'white'
        }

        const inputValues = {
            value: editMode && 'value' in values ? values['value'] : value,
            link: editMode && 'link' in values ? values['link'] : link
        }

        let valueInput

        if (type === 'STRING')
            valueInput = (
                <Input
                    onChange={e => this.handleChangeValue('value', e.target.value)}
                    style={{ marginBottom: '0', width: '100%' }}
                    type="text"
                    placeholder="לא רלוונטי"
                    value={inputValues['value']}
                />
            )
        if (type === 'FLOAT')
            valueInput = (
                <Fragment>
                    <Input
                        disabled={inputValues['value'] === 'NOLIMIT'}
                        onChange={e => this.handleChangeValue('value', e.target.value)}
                        style={{ marginBottom: '0', width: '100%' }}
                        type="number"
                        placeholder={`${inputValues['value'] === 'NOLIMIT' ? 'מוגדר כערך ללא הגבלה' : 'לא רלוונטי'}`}
                        value={inputValues['value']}
                    />
                    <div>
                        <Checkbox
                            checked={inputValues['value'] === 'NOLIMIT'}
                            onChange={e => {
                                if (e.target.checked) {
                                    this.handleChangeValue('value', 'NOLIMIT')
                                } else {
                                    this.handleChangeValue('value', null)
                                }
                            }}
                        />
                        ללא הגבלה
                    </div>
                </Fragment>
            )
        if (type === 'BOOLEAN')
            valueInput = (
                <Select
                    value={inputValues['value']}
                    placeholder="לא רלוונטי"
                    onChange={e => this.handleChangeValue('value', e)}
                >
                    <Select.Option value={null} key="empty">
                        לא רלוונטי
                    </Select.Option>
                    <Select.Option value={'כן'} key="yes">
                        כן
                    </Select.Option>
                    <Select.Option value={'לא'} key="no">
                        לא
                    </Select.Option>
                </Select>
            )

        return (
            <Form
                onSubmit={e => this.handleSubmit(e)}
                style={{
                    width: '100%',
                    padding: '0.5rem 0.8rem',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'space-between',
                    background
                }}
            >
                <div style={{ width: '35%' }}>
                    {policy_id ? <Icon type="check" /> : <Icon type="close" />}
                    <span style={{ marginRight: '0.5rem' }}>{name}</span>
                </div>
                <div style={{ display: 'flex', width: '65%' }}>
                    <div style={{ width: '40%' }}>
                        {!!inputValues['value'] && (
                            <Input
                                value={inputValues['link']}
                                disabled={!inputValues['value']}
                                placeholder="קישור"
                                onChange={e => this.handleChangeValue('link', e.target.value)}
                            />
                        )}
                    </div>
                    <div style={{ width: '40%', paddingRight: '0.5rem' }}>{valueInput}</div>

                    <div style={{ width: '20%', textAlign: 'center' }}>
                        {editMode ? (
                            <Fragment>
                                <Button onClick={() => this.handleCancelEdit()} style={{ margin: '0 0.2rem 0 0' }}>
                                    <Icon type="stop" />
                                </Button>
                                <Button style={{ margin: '0 0.2rem 0 0' }} type="primary" htmlType="submit">
                                    <Icon type="check" />
                                </Button>
                            </Fragment>
                        ) : (
                            <span>ללא שינויים</span>
                        )}
                    </div>
                </div>
            </Form>
        )
    }
}
